import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const generalSettingsKeys = {
    container: generateAutomationName("settings", ["general", "settings", "container"]),
    title: generateAutomationName("settings", ["general", "settings", "filter", "title"]),
    website: generateAutomationName("settings", ["general", "settings", "website", "container"]),
    generalTitle: generateAutomationName("settings", ["general", "settings", "title"]),
    filter: generateAutomationName("settings", ["general", "settings", "filter"]),
    countryFilter: generateAutomationName("settings", ["countryFilter"]),
    preLoader: generateAutomationName("settings", ["preLoader"]),
};
